import {
  Subtitle,
  Radio,
  Form,
  Footer,
  ButtonWithArrowRight,
} from '~components';
import * as Styled from './styled';
import { useTransshipment } from '~contexts/TranshipmentContext';

function DocumentType() {
  const transshipment = useTransshipment();

  const initialValues = {
    documentType: '',
  };

  const handleSubmit = (values) => {
    transshipment.nextStep({
      ...transshipment,
      identityDocumentType: values.documentType,
    });
  };

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={initialValues}
      aria-labelledby="form-document-type-title"
    >
      {({ values }) => {
        return (
          <Styled.Container>
            <Styled.Title id="form-document-type-title">
              Envio de documento de identificação
            </Styled.Title>
            <Subtitle>Primeiro vamos validar a sua identificação.</Subtitle>
            <Styled.Description variant="sub200">
              Qual documentos você deseja utilizar?
            </Styled.Description>
            <Styled.RadioGroup>
              <Radio value="cnh" name="documentType" label="CNH" />
              <Radio value="rg" name="documentType" label="RG" />
            </Styled.RadioGroup>

            <Footer
              marginTop="auto"
              rightButton={
                <ButtonWithArrowRight
                  width="100%"
                  type="submit"
                  variant="primary"
                  disabled={values.documentType === ''}
                >
                  Continuar
                </ButtonWithArrowRight>
              }
            />
          </Styled.Container>
        );
      }}
    </Form>
  );
}

export default DocumentType;
